import React, { useState, useEffect } from "react";

import { useParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import config from "../../../config/config";
import Select from "react-select";
import moment from "moment";
import { toastError, toastSuccess } from "../../../../src/common/Toast";
import {
  DATA_EXPORT,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../../../src/common/Constant";
import Loader from "../../../components/Loader/Loader";
import SplittingConfirmationModal from "../../../components/Modal/SplittingModal";
import { event } from "jquery";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import CommonDatePicker from "../../../components/DatePicker/CommonDatePicker";

function ViewRegisterQuickbook() {
  const paramObject = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("Token");
  const locationid = localStorage.getItem("Location");
  const loginuserid = localStorage.getItem("ID");

  const [loading, setLoading] = useState(false);
  const [showNewRow, setShowNewRow] = useState(false);

  const [searchText, setSearchText] = useState("");

  const [transactionTypeDropdown, setTransactionTypeDropdown] = useState([]);

  console.log(transactionTypeDropdown, "transactionTypeDropdown");
  const [selectTransactionType, setSelectTransactionType] = useState(1);

  const [supplierId, setSupplierId] = useState(0);
  const [customerId, setCustomerId] = useState(0);
  const [employeeId, setEmployeeId] = useState(0);

  const [payeePersonList, setPayeePersonList] = useState([]);

  const [chartOfAccountDropdown, setChartOfAccountDropdown] = useState([]);
  const [chartOfAccountDetails, setChartOfAccountDetails] = useState({});
  const [upperchartOfAccount, setupperChartOfAccount] = useState(0);
  const [lowerchartofaccount, setLowerchartofaccount] = useState(0);
  const [billsquickid, setbillsquickid] = useState(0);
  const [Payeequickid, setPayeequickid] = useState(0);
  const [BillInvoice, setBillInvoice] = useState(0);
  console.log(lowerchartofaccount, Payeequickid, "5555");
  const [selectChartOfAccountId, setSelectChartOfAccountId] = useState(0);
  const [chartOfAccountQuickbookId, setChartOfAccountQuickbookId] = useState(0);
  const [accountAmount, setAccountAmount] = useState(0);

  const [selectedInvoice, setSelectedInvoice] = useState("");
  const [billInvoiceSelect, setBillInvoiceSelect] = useState("");
  const [viewRegisterData, setViewRegisterData] = useState([]);
  const [pendinginvoice, setPendingInvoice] = useState([]);
  const [labelinvoice, setLabelInvoice] = useState([]);

  const [toggleRowIndex, setToggleRowIndex] = useState(0);
  const [stateModal, setStateModal] = useState({ visible: null });

  // console.log(chartOfAccountDropdown, "chartOfAccountDropdown");
  // console.log(transactionTypeDropdown, "transactionTypeDropdown");
  // console.log(chartOfAccountDetails, "chartOfAccountDetails");
  console.log(billInvoiceSelect, "billinvoicechnage");
  console.log(pendinginvoice, "billinvoicechnage");

  const [splits, setSplits] = useState([]);
  const [notlistingdata, setnotlistingdata] = useState([]);
  const [deleteData, setDeleteData] = useState({});

  const [currentPage, setCurrentPage] = useState(1);
  const [startIndex, setStartIndex] = useState(0);
  const [currentData, setCurrentData] = useState([]);
  const ITEMS_PER_PAGE = 150;

  //Date
  //Today
  let today = moment().format("YYYY-MM-DD");
  //Week
  const startOfWeek = moment().startOf("week").format("YYYY-MM-DD");
  const endOfWeek = moment().endOf("week").format("YYYY-MM-DD");
  //This Month
  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
  //Last Month
  const startOfLastMonth = moment()
    .subtract(1, "month")
    .startOf("month")
    .format("YYYY-MM-DD");
  const endOfLastMonth = moment()
    .subtract(1, "month")
    .endOf("month")
    .format("YYYY-MM-DD");
  //This Year
  const startOfYear = moment().startOf("year").format("YYYY-MM-DD");
  const endOfYear = moment().endOf("year").format("YYYY-MM-DD");
  //Last Year
  const startOfLastYear = moment()
    .subtract(1, "year")
    .startOf("year")
    .format("YYYY-MM-DD");
  const endOfLastYear = moment()
    .subtract(1, "year")
    .endOf("year")
    .format("YYYY-MM-DD");

  const startLast7DayDate = moment()
    .subtract(6, "days")
    .startOf("day")
    .format("YYYY-MM-DD");
  const endLast7DayDate = moment().endOf("day").format("YYYY-MM-DD");

  // according to the state customeDate last 7 day
  const [beginningDate, setBeginningDate] = useState(startLast7DayDate);
  const [finalDate, setFinalDate] = useState(endLast7DayDate);
  const [customeDate, setCustomDate] = useState(8);

  // useEffect(() => {
  //   if (customeDate == 1) {
  //     setBeginningDate(today);
  //     setFinalDate(today);
  //   } else if (customeDate == 4) {
  //     setBeginningDate(startOfWeek);
  //     setFinalDate(endOfWeek);
  //   } else if (customeDate == 3) {
  //     setBeginningDate(startOfMonth);
  //     setFinalDate(endOfMonth);
  //   } else if (customeDate == 6) {
  //     setBeginningDate(startOfLastMonth);
  //     setFinalDate(endOfLastMonth);
  //   } else if (customeDate == 5) {
  //     setBeginningDate(startOfYear);
  //     setFinalDate(endOfYear);
  //   } else if (customeDate == 2) {
  //     setBeginningDate(startOfLastYear);
  //     setFinalDate(endOfLastYear);
  //   } else if (customeDate == 8) {
  //     setBeginningDate(startLast7DayDate);
  //     setFinalDate(endLast7DayDate);
  //   } else if (customeDate == 0) {
  //     setBeginningDate("");
  //     setFinalDate("");
  //   }
  // }, []);

  const accountTypeToTransactions = {
    Bank: [
      "Check",
      "Deposit",
      "Sales Receipt",
      "Receive Payment",
      "Bill Payments",
      "Refund",
      "Expense",
      "Bank Transfer",
      "Journal Entry",
    ],
    "Other Current Asset": [
      "Deposit",
      "Sales Receipt",
      "Receive Payment",
      "Refund",
      "Bank Transfer",
      "Journal Entry",
    ],
    "Fixed Asset": ["Bank Transfer", "Journal Entry"],
    "Credit Card": [
      "CC Expense",
      "Expense",
      "CC Credit",
      "Bill Payments",
      "Bank Transfer",
      "Journal Entry",
    ],
    "Other Current Liability": ["Bank Transfer", "Journal Entry"],
    "Long Term Liability": ["Bank Transfer", "Journal Entry"],
    Equity: ["Bank Transfer", "Journal Entry"],
  };

  function getFilteredTransactions(accountType) {
    const allowedTransactions = accountTypeToTransactions[accountType] || [];
    // console.log(allowedTransactions, "filteredTransactions");
    return transactionTypeDropdown.filter((transaction) =>
      allowedTransactions.includes(transaction?.label)
    );
  }

  const filteredTransactions = getFilteredTransactions(
    chartOfAccountDetails?.AccountType
  );

  // console.log(
  //   chartOfAccountDetails?.AccountType,
  //   filteredTransactions,
  //   "filteredTransactions"
  // );

  console.log(chartOfAccountDetails, "chartOfAccountDetails");

  const dateOptions = [
    { label: "All", value: 0 },
    { label: "Today", value: 1 },
    { label: "This Week", value: 4 },
    { label: "This Month", value: 3 },
    { label: "Last Month", value: 6 },
    { label: "This Year", value: 5 },
    { label: "Last Year", value: 2 },
    { label: "Custom", value: 7 },
    { label: "Last 7 Day", value: 8 },
  ];

  const selectDropdownStyles = {
    control: (provided, state) => ({
      ...provided,
      border: state.isFocused ? "1px solid orange" : "1px solid #ccc",
      boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
      "&:hover": {
        border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      },
    }),
  };

  const inputStyles = {
    width: "92%",
    display: "block",
    // padding: '0.375rem 0.75rem',
    fontSize: "12px",
    marginLeft: "5px",
    fontWeight: 400,
    lineHeight: 1.5,
    color: "#212529",
    // backgroundColor: '#fff',
    backgroundClip: "padding-box",
    border: "1px solid #ced4da",
    appearance: "none",
    borderRadius: "8px",
    transition: "border-color .15s ease-in-out, box-shadow .15s ease-in-out",
  };

  const handleDateFilter = (event) => {
    // console.log(event, "eventtt");
    setCustomDate(event?.value);
    if (event?.value == 1) {
      setBeginningDate(today);
      setFinalDate(today);
    } else if (event?.value == 4) {
      setBeginningDate(startOfWeek);
      setFinalDate(endOfWeek);
    } else if (event?.value == 3) {
      setBeginningDate(startOfMonth);
      setFinalDate(endOfMonth);
    } else if (event?.value == 6) {
      setBeginningDate(startOfLastMonth);
      setFinalDate(endOfLastMonth);
    } else if (event?.value == 5) {
      setBeginningDate(startOfYear);
      setFinalDate(endOfYear);
    } else if (event?.value == 2) {
      setBeginningDate(startOfLastYear);
      setFinalDate(endOfLastYear);
    } else if (event?.value == 8) {
      setBeginningDate(startLast7DayDate);
      setFinalDate(endLast7DayDate);
    } else if (event?.value == 0) {
      setBeginningDate(today);
      setFinalDate(today);
    } else {
      setBeginningDate(today);
      setFinalDate(today);
    }
  };

  //Date
  const handleDate = (event) => {
    if (event && event.length > 0) {
      // console.log(event?.target?.value, "eventisss92");
      setBeginningDate(event);
      setCustomDate(7);
    }
  };

  const handleEndDate = (event) => {
    if (event && event.length > 0) {
      // console.log(event?.target?.value, "eventisss92");
      setFinalDate(event);
      setCustomDate(7);
    }
    // setCustomDate(7);
  };

  const transactionType = () => {
    // payee Api
    axios
      .get(
        `${config.accountingBaseUrl}/chartofaccounts/getalltransactiontype?isshowviewregister=1`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        const transactionType = res.data.ResponseData.map((u) => ({
          label: u.Name,
          value: u.ID,
        }));
        setTransactionTypeDropdown(transactionType);
        console.log("res280", res.data.ResponseData);
      });
  };

  const payeeAPI = () => {
    // Payee Api
    axios
      .get(
        `${config.appointmentBaseUrl}/appointments/appointmentpersonddl?isCustomer=0`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        const appointmentPersonOptions = res.data.ResponseData.map((u) => {
          const UserType =
            u.IsCustomer === 1
              ? "Customer"
              : u.IsCustomer === 0
              ? "Supplier"
              : "Employee";
          return {
            label: `${u.FirstName} (${UserType})`,
            value: u.Id,
            QuickBookId: u.QuickBookId,
            IsCustomer: u.IsCustomer,
            UserType: UserType,
            Type: "payee",
          };
        });
        setPayeePersonList(appointmentPersonOptions);
        // console.log("res ", appointmentPersonOptions);
      });
  };

  const newTransactionTypeDropdownOption = transactionTypeDropdown.filter(
    (el) => el.value != 3 && el.value != 8 && el.value != 9
  );

  const AccountAPI = () => {
    // Chart of Account Dropdown for account id
    axios
      .get(`${config.accountingBaseUrl}/chartofaccounts/accountddl`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        const accountTypeDropdownOption = res.data.ResponseData?.filter(
          (e) => e?.IsViewRegister == 1
        )?.map((u) => ({
          label: u.Name,
          value: u.ID,
          amount: u.Amount,
          QuickbookId: u.QuickbookId,
          AccountType: u.AccountType,
          type: "account",
        }));

        setChartOfAccountDropdown(accountTypeDropdownOption);

        setChartOfAccountDetails(
          accountTypeDropdownOption?.find((el) => el?.value == paramObject?.id)
        );

        const accontfiler = res.data.ResponseData.filter(
          (el) => el.ID == paramObject?.id
        );
        console.log(accontfiler, accontfiler[0]?.QuickbookId, "5555");
        setupperChartOfAccount(accontfiler[0]?.QuickbookId);

        const filterAccount = res.data.ResponseData.find(
          (option) => option?.ID === paramObject.id
        );

        if (filterAccount) {
          setChartOfAccountQuickbookId(filterAccount?.QuickbookId);
          setAccountAmount(filterAccount?.Amount);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  function calculateBalance(entries) {
    let finalBalance = 0;
    const ArrayVRegister = [];

    entries.forEach((entry, index) => {
      // Update balance based on deposit and payment

      if (entry?.AccountTypeID === 11) {
        finalBalance -= Number(entry?.Deposit);
        finalBalance += Number(entry?.Payment);
        console.log("+",Number(entry?.Payment),"-", Number(entry?.Deposit), finalBalance, entry?.AccountTypeID, "finalBalance 11");
      } else {
        console.log(entry?.ID, entry?.Payment, "payment")
        finalBalance += Number(entry?.Deposit);
        finalBalance -= Number(entry?.Payment);
        console.log("-",Number(entry?.Payment),"+", Number(entry?.Deposit), finalBalance, entry?.AccountTypeID, "finalBalance 0");
      }
      // Store the balance after each entry
      ArrayVRegister.push({
        ...entry,
        entryNumber: index + 1,
        Deposit: entry?.Deposit,
        Payment: entry?.Payment,
        Balance: finalBalance,
        Date: entry?.Date ? moment(entry?.Date).format("MM/DD/YYYY") : "",
      });
    });

    const OrderByDesc = ArrayVRegister?.sort((a, b) => {
      return (
        moment(b.CreatedModifiedDate).toDate() -
        moment(a.CreatedModifiedDate).toDate()
      );
    });

    // console.log(OrderByDesc.map(el => el.ID), "OrderByDesc");
    console.log(OrderByDesc, "OrderByDesc");
    // ArrayVRegister
    return {
      OrderByDesc,
      finalBalance,
    };
  }

  const handleViewRegisterAPI = (
    searchtext,
    selectTransactionType,
    customerid,
    supplierid,
    startdate,
    enddate,
    selectChartOfAccountId,
    employeeId
  ) => {
    setLoading(true);
    setViewRegisterData([]);
    axios
      .get(
        `${
          config.accountingBaseUrl
        }/chartofaccounts/accountviewregisterV2?searchtext=${searchtext}&transactiontype=${selectTransactionType}&customerid=${
          customerid ? customerid : 0
        }&supplierid=${supplierid ? supplierid : 0}&employeeid=${
          employeeId ? employeeId : 0
        }&startdate=${customeDate !== 0 ? startdate : ""}&enddate=${
          customeDate !== 0 ? enddate : ""
        }&locationid=${locationid}&accountid=${selectChartOfAccountId}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("response ==>", res.data.ResponseData);

        const newarr = res.data.ResponseData?.map((el) => {
          return {
            ...el,
            showDelete: true,
            Payment: el?.Payment ? parseFloat(el?.Payment).toFixed(2) : 0,
            Deposit: el?.Deposit ? parseFloat(el?.Deposit).toFixed(2) : 0,
            showAll: el.Type === "Expense" ? true : false,
          };
        });

        console.log(newarr, "balance data check");
        const FinalData = calculateBalance(newarr);
        console.log(FinalData, "balance data check");

        setViewRegisterData(FinalData?.OrderByDesc); //newarr //ArrayVRegister
        setCurrentData(FinalData?.OrderByDesc?.slice(0, ITEMS_PER_PAGE));
        // setViewRegisterFinalBalance(FinalData?.finalBalance); //newarr

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const fetchdata = (
    transactionid,
    payeeid,
    payeeusertype,
    locationid,
    startdate,
    enddate
  ) => {
    setPendingInvoice([]);
    axios
      .get(
        `${config.accountingBaseUrl}/chartofaccounts/viewregisterpendinginvoiceandbills?transactiontypeid=${transactionid}&payeeid=${payeeid}&payeeusertype=${payeeusertype}&locationid=${locationid}&startdate=${startdate}&enddate=${enddate}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("invoicedata", res.data.ResponseData[0].QuickBookId);

        const datadropdown = res.data.ResponseData?.map((u, i) => {
          return {
            label: u.Name,
            value: u.ID,
            total: u.PaymentBalance,
            QuickBookId: u.QuickBookId,
            Type: "Bills",
          };
        });

        setPendingInvoice(datadropdown);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSubmit = (type, index, issplit) => {
    let requestPayload = {};
    if (type == "edit") {
      let selectedRowsData = viewRegisterData[index];
      console.log(selectedRowsData, "66656");
      requestPayload = {
        id: selectedRowsData?.ID > 0 ? selectedRowsData?.ID : 0,
        accountid: paramObject?.id ? paramObject?.id : 0,
        transactiontypeid: selectedRowsData?.TransactionTypeID,
        date: selectedRowsData?.Date,
        refno: selectedRowsData?.RefNo,
        payeeid: selectedRowsData?.PayeeId,
        payeeusertype: selectedRowsData?.PayeeUserType,
        accountcategoryid: selectedRowsData?.AccountID,
        Upperaccount: upperchartOfAccount,
        lowerchartofaccount: lowerchartofaccount,
        Payeequickbookid: Payeequickid,
        BillInvoice: BillInvoice,
        billsquickid: billsquickid,
        QuickbookId: selectedRowsData?.QuickbookId,
        memo: selectedRowsData?.Memo,
        payment: selectedRowsData?.Payment,
        deposit: selectedRowsData?.Deposit,
        cr: selectedRowsData?.cr,
        locationid: locationid,
        loginuserid: loginuserid,
        issplit: issplit ? issplit : 0,
        module: selectedRowsData?.Module,
      };
    } else {
      let selectedRowsData = viewRegisterData[0];

      if (
        selectedRowsData?.TransactionTypeID == 6 ||
        selectedRowsData?.TransactionTypeID == 7 ||
        selectedRowsData?.TransactionTypeID == 11
      ) {
        if (selectedRowsData?.PayeeId < 1) {
          toastError("Please Select Payeee");
          return;
        }
      }

      if (selectedRowsData?.AccountID < 1) {
        toastError("Please Select Account");
        return;
      }

      if (selectedRowsData?.Deposit < 1) {
        if (selectedRowsData?.Payment < 1) {
          toastError("Please FIll Amount");
          return;
        }
      }

      requestPayload = {
        id: 0,
        accountid: paramObject?.id ? paramObject?.id : 0,
        transactiontypeid: selectedRowsData.TransactionTypeID,
        date: selectedRowsData?.Date,
        refno: selectedRowsData?.RefNo,
        payeeid: selectedRowsData?.PayeeId,
        payeeusertype: selectedRowsData?.PayeeUserType,
        accountcategoryid: selectedRowsData?.AccountID,
        Upperaccount: upperchartOfAccount,
        lowerchartofaccount: lowerchartofaccount,
        Payeequickbookid: Payeequickid,
        BillInvoice: BillInvoice,
        billsquickid: billsquickid,
        memo: selectedRowsData?.Memo,
        payment: selectedRowsData?.Payment,
        deposit: selectedRowsData?.Deposit,
        cr: selectedRowsData?.cr,
        locationid: locationid,
        loginuserid: loginuserid,
        issplit: 0,
        quickbookid: selectedRowsData?.PayeeQuickbookId,
      };
    }

    console.log("requestPayload ==>", type, requestPayload);
    // return;

    setLoading(true);
    axios
      .post(
        `${config.accountingBaseUrl}/chartofaccounts/accountviewregisterupsert`,
        requestPayload,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // console.log("res data ==========>>>>", res);
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          setShowNewRow(false);
          handleViewRegisterAPI(
            searchText,
            selectTransactionType,
            customerId,
            supplierId,
            beginningDate,
            finalDate,
            paramObject?.id,
            employeeId
          );
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  // const descRowsData = viewRegisterData?.sort((a, b) => {
  //   return b?.row_num - a?.row_num;
  // });

  const handleEdit = (value, id, isExpanse, RecSaleID) => {
    console.log(value, id, isExpanse, RecSaleID, "handelEdit");
    // return
    if (isExpanse === "Expense") {
      navigate(`/Expense/${RecSaleID}`);
    }

    if (value == 8 || value == 9) {
      navigate(`/manage-sales/${id}`);
    }

    if (value == 6) {
      navigate(`/Expense/${RecSaleID}`);
    }
    if (value == 5) {
      navigate(`/manage-receiving/${RecSaleID}`);
    }
    if (value == 3) {
      navigate(`/manage-receiving/${id}`);
    }

    if (value == 7) {
      navigate(`/receiving-paybills/${id}`);
    }

    if (value == 11) {
      // navigate(`/recvpayment/${id}`);
      navigate(`/receive-payment/${id}`);
    }

    if (value == 12) {
      navigate(`/bank-deposit/${id}`);
    }

    if (value == 13) {
      navigate(`/manage-transfer/${id}`);
    }

    if (value == 14) {
      navigate(`/journal-entry/${id}`);
    }
  };

  //Delete  after check
  const handleDeleteClick = (item, index) => {
    const deleteFinalData = {
      DeleteIndex: index,
      ID: item?.ID,
      viewregasterQuickbookIds: item?.QuickbookId,
      Transferquickbookid: item?.Transferquickbookid,
      Deposit: item?.Deposit,
      Payment: item?.Payment,
      TransactionTypeID: item?.TransactionTypeID,
      TransactionType: item?.TransactionTypeID,
      ModuleDelete: item?.Module,
    };

    console.log(deleteFinalData, "deleteFinalData 1");
    // return;
    // if (item.QuickbookId > 0) {
    //   if (item.Module === "RECEIVEPAYMENT") {
    //     setLoading(true);
    //     axios
    //       .get(
    //         `${config.accountingBaseUrl}/chartofaccounts/deletedataviewregister?ID=${item.ID}&Module=RECEIVEPAYMENT`,
    //         {
    //           headers: {
    //             "Content-Type": "application/json;charset=UTF-8",
    //             Authorization: token,
    //           },
    //         }
    //       )
    //       .then((res) => {
    //         setLoading(false);
    //         //console.log(res.data.ResponseData, "mydear");
    //         setnotlistingdata(res.data.ResponseData);

    //         setStateModal({ visible: index });
    //       })
    //       .catch((error) => {
    //         setLoading(false);
    //       });
    //   } else if (item.Module === "PAYBILLS") {
    //     setLoading(true);
    //     axios
    //       .get(
    //         `${config.accountingBaseUrl}/chartofaccounts/deletedataviewregister?ID=${item.ID}&Module=PAYBILLS`,
    //         {
    //           headers: {
    //             "Content-Type": "application/json;charset=UTF-8",
    //             Authorization: token,
    //           },
    //         }
    //       )
    //       .then((res) => {
    //         setLoading(false);
    //         //console.log(res.data.ResponseData, "mydear");
    //         setnotlistingdata(res.data.ResponseData);

    //         setStateModal({ visible: index });
    //       })
    //       .catch((error) => {
    //         setLoading(false);
    //       });
    //   } else {
    //     setnotlistingdata([]);
    //     setStateModal({ visible: index });
    //   }
    // } else {

    setnotlistingdata([]);
    setStateModal({ visible: index });

    setDeleteData(deleteFinalData);
    // setDeleteIndex(index);
    // setID(item.ID);
    // setviewregasterQuickbookIds(item.QuickbookId);
    // setTransferquickbookid(item.Transferquickbookid);
    // setDeposit(item.Deposit);
    // setPayment(item.Payment);
    // setTransactionTypeID(item.TransactionTypeID);
    // setTransactionType(item.TransactionTypeID);
    // setModuleDelete(item.Module);
  };

  const handlePayeeType = (event) => {
    // console.log("event242", event,);

    if (event?.IsCustomer == 1) {
      // customer
      setSupplierId(0);
      setEmployeeId(0);
      setCustomerId(event?.value);
    } else if (event?.IsCustomer == 2) {
      // employeee
      setSupplierId(0);
      setCustomerId(0);
      setEmployeeId(event?.value);
    } else {
      // supplier
      setSupplierId(event?.value);
      setCustomerId(0);
      setEmployeeId(0);
    }
  };

  // after check
  const handleConfirmDelete = (index) => {
    // const rows = [...rowsData];
    // rows.splice(deleteIndex, 1);
    // setRowsData(rows);

    setStateModal({ visible: null });

    const DeleteFinalData = {
      id: deleteData?.ID, // state
      quickbookid: deleteData?.viewregasterQuickbookIds, // state
      Transferquickbookid: deleteData?.Transferquickbookid, // state
      Deposit: deleteData?.Deposit, // state
      Payment: deleteData?.Payment, // state
      rootquickbookid: chartOfAccountQuickbookId, //
      TransactionTypeID: deleteData?.TransactionTypeID, // state
      loginuserid: loginuserid,
      transactiontype: deleteData?.TransactionType, // state
      module: deleteData?.ModuleDelete, // state
      notlistingdata: notlistingdata,
    };

    console.log(DeleteFinalData, "deleteFinalData 2");
    // return;

    axios
      .post(
        `${config.accountingBaseUrl}/chartofaccounts/viewregisterdelete`,
        DeleteFinalData,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setnotlistingdata([]);
        setDeleteData([]);
        toastSuccess(SUCCESS_MESSAGE);
        handleViewRegisterAPI(
          searchText,
          selectTransactionType,
          customerId,
          supplierId,
          beginningDate,
          finalDate,
          paramObject?.id, //accountId,
          employeeId
        );
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  // new row cancle
  const handleRemove = () => {
    let NewViewRegisterData = [...viewRegisterData];
    NewViewRegisterData.shift();

    setViewRegisterData([]);

    setTimeout(() => {
      setViewRegisterData(NewViewRegisterData);
      setCurrentData(NewViewRegisterData?.slice(0, ITEMS_PER_PAGE));
      setCurrentPage(1);
      setStartIndex(0);
    }, 100);

    setShowNewRow(false);
    setLabelInvoice([]);
  };

  const handleAccountChange = (e) => {
    setupperChartOfAccount(e?.QuickbookId);
    setAccountAmount(e?.amount);
    e?.value != undefined && navigate(`/vregister/${e?.value}`);
  };

  const handleInputChange = (event, index, fieldName, currentDataIndex) => {
    console.log(event, index, fieldName, "131");

    if (event?.Type == "payee") {
      setPayeequickid(event?.QuickBookId);
    }
    if (event?.type == "account") {
      setLowerchartofaccount(event?.QuickbookId);
    }
    if (event?.Type == "Bills") {
      setbillsquickid(event?.QuickBookId);
    }
    if (fieldName == "BillInvoice") {
      setBillInvoice(event?.QuickBookId);
    }

    if (fieldName === "Type") {
      const updatedData = [...viewRegisterData];

      updatedData[index] = {
        ...updatedData[index],
        [fieldName]: event?.label,
        ["TransactionTypeID"]: event?.value,
        ["PayeeId"]: 0,
        ["PayeeUserType"]:
          event?.value == 6 ||
          event?.value == 13 ||
          event?.value == 14 ||
          event?.value == 20 ||
          event?.value == 21 ||
          event?.value == 15 ||
          event?.value == 12
            ? ""
            : event?.value == 17 || event?.value == 11 || event?.value == 22
            ? "Customer"
            : "Supplier", // Supplier  7 id
        ["showAll"]:
          event?.value == 6 ||
          event?.value == 13 ||
          event?.value == 14 ||
          event?.value == 20 ||
          event?.value == 21 ||
          event?.value == 15 ||
          event?.value == 12
            ? true
            : false,
      };
      console.log(updatedData[currentDataIndex], "updateType");
      setPendingInvoice([]);
      setSelectedInvoice("");
      setLabelInvoice([]);
      setBillInvoiceSelect(null);
      setViewRegisterData(updatedData);
      // if (event?.value == 7 || event?.value == 11) {
      //   if (payee) {
      //     fetchdata(
      //       event?.value,
      //       payeeid,
      //       payeeusertype,
      //       locationid,
      //       beginningDate,
      //       finalDate
      //     );
      //   }
      //   setDropdown(true);
      //   setType(true);
      // }

      // for current data
      const updatedCurrentData = [...currentData];
      updatedCurrentData[currentDataIndex] = {
        ...updatedCurrentData[currentDataIndex],
        [fieldName]: event?.label,
        ["TransactionTypeID"]: event?.value,
        ["PayeeId"]: 0,
        ["PayeeUserType"]:
          event?.value == 6 ||
          event?.value == 13 ||
          event?.value == 14 ||
          event?.value == 20 ||
          event?.value == 21 ||
          event?.value == 15 ||
          event?.value == 12
            ? ""
            : event?.value == 17 || event?.value == 11 || event?.value == 22
            ? "Customer"
            : "Supplier", // Supplier  7 id
        ["showAll"]:
          event?.value == 6 ||
          event?.value == 13 ||
          event?.value == 14 ||
          event?.value == 20 ||
          event?.value == 21 ||
          event?.value == 15 ||
          event?.value == 12
            ? true
            : false,
      };
      setCurrentData(updatedCurrentData);
    } else if (fieldName === "Date") {
      const updatedData = [...viewRegisterData];
      updatedData[index] = {
        ...updatedData[index],
        [fieldName]: event?.target?.value,
      };
      const datetime =
        moment(updatedData[0]?.Date).format("YYYY-MM-DDT00:00:00.000") + "Z";
      const settime = moment(datetime).format("YYYY-MM-DD");
      console.log(settime, "settime");
      setViewRegisterData(settime);
      // setViewRegisterData(updatedData);

      // for current data
      const updatedCurrentData = [...currentData];
      updatedCurrentData[currentDataIndex] = {
        ...updatedCurrentData[currentDataIndex],
        [fieldName]: event?.target?.value,
      };
      setCurrentData(updatedCurrentData);
    } else if (fieldName === "RefNo") {
      const updatedData = [...viewRegisterData];
      updatedData[index] = {
        ...updatedData[index],
        [fieldName]: event,
      };
      setViewRegisterData(updatedData);

      // for current data
      const updatedCurrentData = [...currentData];
      updatedCurrentData[currentDataIndex] = {
        ...updatedCurrentData[currentDataIndex],
        [fieldName]: event,
      };
      setCurrentData(updatedCurrentData);
    } else if (fieldName === "PayeeId") {
      const updatedData = [...viewRegisterData];
      updatedData[index] = {
        ...updatedData[index],
        [fieldName]: event?.value,
        ["Payee"]: event?.label,
        ["PayeeQuickbookId"]: event?.QuickBookId,
        ["PayeeUserType"]:
          event?.IsCustomer == 1
            ? "Customer"
            : event?.IsCustomer == 0
            ? "Supplier"
            : "Employee",
      };
      setBillInvoiceSelect(null);

      if (
        updatedData[index]?.TransactionTypeID == 7 ||
        updatedData[index]?.TransactionTypeID == 11
      ) {
        fetchdata(
          updatedData[index]?.TransactionTypeID,
          updatedData[index]?.PayeeId,
          updatedData[index]?.PayeeUserType,
          locationid,
          "",
          ""
          // beginningDate,
          // finalDate
        );
      }
      setViewRegisterData(updatedData);

      // for current data
      const updatedCurrentData = [...currentData];
      updatedCurrentData[currentDataIndex] = {
        ...updatedCurrentData[currentDataIndex],
        [fieldName]: event?.value,
        ["Payee"]: event?.label,
        ["PayeeQuickbookId"]: event?.QuickBookId,
        ["PayeeUserType"]:
          event?.IsCustomer == 1
            ? "Customer"
            : event?.IsCustomer == 0
            ? "Supplier"
            : "Employee",
      };

      if (
        updatedCurrentData[currentDataIndex]?.TransactionTypeID == 7 ||
        updatedCurrentData[currentDataIndex]?.TransactionTypeID == 11
      ) {
        fetchdata(
          updatedCurrentData[currentDataIndex]?.TransactionTypeID,
          updatedCurrentData[currentDataIndex]?.PayeeId,
          updatedCurrentData[currentDataIndex]?.PayeeUserType,
          locationid,
          "",
          ""
          // beginningDate,
          // finalDate
        );
      }

      setCurrentData(updatedCurrentData);
    } else if (fieldName === "AccountID") {
      const updatedData = [...viewRegisterData];
      updatedData[index] = {
        ...updatedData[index],
        // [fieldName]: event,
        [fieldName]: event?.value,
        ["AccountQuickbookID"]: event?.QuickbookId,
      };
      setViewRegisterData(updatedData);

      // for current data
      const updatedCurrentData = [...currentData];
      updatedCurrentData[currentDataIndex] = {
        ...updatedCurrentData[currentDataIndex],
        // [fieldName]: event,
        [fieldName]: event?.value,
        ["AccountQuickbookID"]: event?.QuickbookId,
      };

      setCurrentData(updatedCurrentData);
    } else if (fieldName === "Memo") {
      const updatedData = [...viewRegisterData];
      updatedData[index] = {
        ...updatedData[index],
        [fieldName]: event?.target?.value,
      };
      setViewRegisterData(updatedData);

      // for current data
      const updatedCurrentData = [...currentData];
      updatedCurrentData[currentDataIndex] = {
        ...updatedCurrentData[currentDataIndex],
        [fieldName]: event?.target?.value,
      };
      setCurrentData(updatedCurrentData);
    } else if (fieldName === "Payment" || fieldName === "Deposit") {
      const updatedData = [...viewRegisterData];
      updatedData[index] = {
        ...updatedData[index],
        [fieldName]: event?.target?.value,
      };

      // Check if one field has a value and the other doesn't, then update accordingly
      if (fieldName === "Payment" && updatedData[index]["Deposit"]) {
        updatedData[index]["Deposit"] = 0;
      } else if (fieldName === "Deposit" && updatedData[index]["Payment"]) {
        updatedData[index]["Payment"] = 0;
      }

      setViewRegisterData(updatedData);

      // for current data
      const updatedCurrentData = [...currentData];
      updatedCurrentData[currentDataIndex] = {
        ...updatedCurrentData[currentDataIndex],
        [fieldName]: event?.target?.value,
      };

      // Check if one field has a value and the other doesn't, then update accordingly
      if (
        fieldName === "Payment" &&
        updatedCurrentData[currentDataIndex]["Deposit"]
      ) {
        updatedCurrentData[currentDataIndex]["Deposit"] = 0;
      } else if (
        fieldName === "Deposit" &&
        updatedCurrentData[currentDataIndex]["Payment"]
      ) {
        updatedCurrentData[currentDataIndex]["Payment"] = 0;
      }

      setCurrentData(updatedCurrentData);
    } else if (fieldName === "BillInvoice") {
      console.log(event, "events==>");

      setBillInvoiceSelect(event?.value ? event?.value : null);

      let event1 = event ? [event] : [];

      setLabelInvoice(event1);

      const updatedData = [...viewRegisterData];
      updatedData[0]["BillQuickbookId"] = event?.QuickBookId;
      if (updatedData[0]?.TransactionTypeID == 7) {
        updatedData[0]["Deposit"] = 0;
        updatedData[0]["Payment"] = event?.total;
      } else if (updatedData[0]?.TransactionTypeID == 11) {
        updatedData[0]["Payment"] = 0;
        updatedData[0]["Deposit"] = event?.total;
      }

      updatedData[0] = {
        ...updatedData[0],
        [fieldName]: event1.map((el) => el.value).join(","),
      };

      setSelectedInvoice(event1.map((el) => el.value).join(","));
      setViewRegisterData(updatedData);

      // for current data
      const updatedCurrentData = [...currentData];
      updatedCurrentData[0]["BillQuickbookId"] = event?.QuickBookId;
      if (updatedCurrentData[0]?.TransactionTypeID == 7) {
        updatedCurrentData[0]["Deposit"] = 0;
        updatedCurrentData[0]["Payment"] = event?.total;
      } else if (updatedCurrentData[0]?.TransactionTypeID == 11) {
        updatedCurrentData[0]["Payment"] = 0;
        updatedCurrentData[0]["Deposit"] = event?.total;
      }

      updatedCurrentData[0] = {
        ...updatedCurrentData[0],
        [fieldName]: event1.map((el) => el.value).join(","),
      };

      setCurrentData(updatedCurrentData);
    }
    // else if (fieldName === "cr") {
    //   const updatedData = [...viewRegisterData];
    //   updatedData[index] = {
    //     ...updatedData[index],
    //     [fieldName]: event?.target?.value,
    //   };
    //   setViewRegisterData(updatedData);
    // }
  };

  const handleRowInputClick = (index, currentDataIndex) => {
    const updatedData = [...viewRegisterData];
    const updatedCurrentData = [...currentData];
    const currentIndex = toggleRowIndex % 3;

    if (currentIndex === 0) {
      updatedData[index] = {
        ...updatedData[index],
        cr: "C",
      };
    } else if (currentIndex === 1) {
      updatedData[index] = {
        ...updatedData[index],
        cr: "R",
      };
    } else {
      updatedData[index] = {
        ...updatedData[index],
        cr: "",
      };
    }

    if (currentIndex === 0) {
      updatedCurrentData[currentDataIndex] = {
        ...updatedCurrentData[currentDataIndex],
        cr: "C",
      };
    } else if (currentIndex === 1) {
      updatedCurrentData[currentDataIndex] = {
        ...updatedCurrentData[currentDataIndex],
        cr: "R",
      };
    } else {
      updatedCurrentData[currentDataIndex] = {
        ...updatedCurrentData[currentDataIndex],
        cr: "",
      };
    }

    setToggleRowIndex(currentIndex + 1);
    setViewRegisterData(updatedData);
    setCurrentData(updatedCurrentData);
  };

  const Spilliting = (item) => {
    const items = item.split(",");
    // localStorage.setItem("Splits", JSON.stringify(items));
    setSplits(items);
  };

  //close
  const handleClose = () => {
    //setShowDeleteModal(false);
    setStateModal({ visible: null });
  };

  const handleCancelDelete = () => {
    //setShowDeleteModal(false);
    setStateModal({ visible: null });
  };

  // check Account Type is Payable/Receivable return true/ false
  const accountId = chartOfAccountDropdown?.some(
    (option) =>
      option.value == (paramObject?.id == undefined ? 0 : paramObject?.id) &&
      (option.AccountType === "Accounts Receivable" ||
        // option.AccountType === "Credit Card" ||
        option.AccountType === "Accounts Payable")
  );

  // check Account Type is Credit Card return true/ false
  const otherAccountId = chartOfAccountDropdown?.some(
    (option) =>
      option.value == (paramObject?.id == undefined ? 0 : paramObject?.id) &&
      // (option.AccountType === "Accounts Receivable" ||
      option.AccountType === "Credit Card" // ||
    // option.AccountType === "Accounts Payable"
  );

  // const orderColumn = "desc";
  // const handelSortByAscDesc = (event) => {
  //   const columnName = event?.target?.id;
  //   // setShowSortData(true);
  //   console.log(columnName, "column name of click on tag");

  //   const sortOrder = orderColumn === "desc" ? "asc" : "desc";
  //   console.log("in function 145 rowsData before call");

  //   if (columnName === "Payment") {
  //     if (sortOrder === "asc") {
  //       setViewRegisterData(
  //         viewRegisterData
  //           .slice()
  //           .sort((a, b) => parseFloat(a.Payment) - parseFloat(b.Payment))
  //       );
  //     } else {
  //       setViewRegisterData(
  //         viewRegisterData
  //           .slice()
  //           .sort((a, b) => parseFloat(b.Payment) - parseFloat(a.Payment))
  //       );
  //     }
  //   } else if (columnName === "Balance") {
  //     if (sortOrder === "asc") {
  //       setViewRegisterData(
  //         viewRegisterData
  //           .slice()
  //           .sort((a, b) => parseFloat(a.Balance) - parseFloat(b.Balance))
  //       );
  //     } else {
  //       setViewRegisterData(
  //         viewRegisterData
  //           .slice()
  //           .sort((a, b) => parseFloat(b.Balance) - parseFloat(a.Balance))
  //       );
  //     }
  //   } else if (columnName === "Deposit") {
  //     if (sortOrder === "asc") {
  //       setViewRegisterData(
  //         viewRegisterData
  //           .slice()
  //           .sort((a, b) => parseFloat(a.Deposit) - parseFloat(b.Deposit))
  //       );
  //     } else {
  //       setViewRegisterData(
  //         viewRegisterData
  //           .slice()
  //           .sort((a, b) => parseFloat(b.Deposit) - parseFloat(a.Deposit))
  //       );
  //     }
  //   } else if (columnName === "Memo") {
  //     if (sortOrder === "asc") {
  //       setViewRegisterData(
  //         viewRegisterData.slice().sort((a, b) => {
  //           const memoA = a.Memo || ""; // Handle cases where Memo is null or undefined
  //           const memoB = b.Memo || "";

  //           return memoA.localeCompare(memoB);
  //         })
  //       );
  //     } else {
  //       setViewRegisterData(
  //         viewRegisterData.slice().sort((a, b) => {
  //           const memoA = a.Memo || ""; // Handle cases where Memo is null or undefined
  //           const memoB = b.Memo || "";

  //           return memoB.localeCompare(memoA);
  //         })
  //       );
  //     }
  //   } else if (columnName === "Payee") {
  //     if (sortOrder === "asc") {
  //       setViewRegisterData(
  //         viewRegisterData.slice().sort((a, b) => {
  //           const payeeA = a.Payee || ""; // Handle cases where Memo is null or undefined
  //           const payeeB = b.Payee || "";

  //           return payeeA.localeCompare(payeeB);
  //         })
  //       );
  //     } else {
  //       setViewRegisterData(
  //         viewRegisterData.slice().sort((a, b) => {
  //           const payeeA = a.Payee || ""; // Handle cases where Memo is null or undefined
  //           const payeeB = b.Payee || "";

  //           return payeeB.localeCompare(payeeA);
  //         })
  //       );
  //     }
  //   } else if (columnName === "AccountID") {
  //     sortOrder === "asc"
  //       ? setViewRegisterData(
  //           viewRegisterData.slice().sort((a, b) => a.AccountID - b.AccountID)
  //         )
  //       : setViewRegisterData(
  //           viewRegisterData.slice().sort((a, b) => b.AccountID - a.AccountID)
  //         );
  //   } else if (columnName === "Type") {
  //     sortOrder === "asc"
  //       ? setViewRegisterData(
  //           viewRegisterData
  //             .slice()
  //             .sort((a, b) => a.Type.localeCompare(b.Type))
  //         )
  //       : setViewRegisterData(
  //           viewRegisterData
  //             .slice()
  //             .sort((a, b) => b.Type.localeCompare(a.Type))
  //         );
  //   } else if (columnName === "Date") {
  //     sortOrder === "asc"
  //       ? setViewRegisterData(
  //           viewRegisterData
  //             .slice()
  //             .sort((a, b) => new Date(a.Date) - new Date(b.Date))
  //         )
  //       : setViewRegisterData(
  //           viewRegisterData
  //             .slice()
  //             .sort((a, b) => new Date(b.Date) - new Date(a.Date))
  //         );
  //   } else if (columnName === "RefNo") {
  //     sortOrder === "asc"
  //       ? setViewRegisterData(
  //           viewRegisterData
  //             .slice()
  //             .sort((a, b) => (a.RefNo || "").localeCompare(b.RefNo || ""))
  //         )
  //       : setViewRegisterData(
  //           viewRegisterData
  //             .slice()
  //             .sort((a, b) => (b.RefNo || "").localeCompare(a.RefNo || ""))
  //         );
  //   }
  //   console.log("column not matched");
  //   // setOrderColumn(sortOrder);
  //   // setRowsData(sortedArray);
  // };

  const addNewRowForViewRegister = () => {
    if (!showNewRow) {
      const newRow = {
        RowNumber: 0,
        ID: 0,
        Date: moment().format("YYYY-MM-DD"),
        FromAccountID: 0,
        Transferquickbookid: 0,
        RefNo: "",
        Payee: "",
        Name: "",
        Memo: "",
        Account: 0,
        AccountName: "",
        Payment: "0",
        Deposit: "0",
        Module: "",
        PayeeId: 0,
        PayeeUserType: getPayeeUserType(filteredTransactions),
        AccountID: paramObject?.id ?? 0,
        TransactionTypeID: filteredTransactions?.[0]?.value ?? 0,
        Type: filteredTransactions?.[0]?.label ?? 0,
        IsSplit: 0,
        SplitRecords: "",
        IsDefaultBalance: 0,
        AmountPaid: "",
        CreditNote: "",
        RecSaleID: 0,
        QuickbookId: 0,
        CreatedModifiedDate: "",
        cr: "",
        Deleted: 0,
        IsCustomerSplit: 0,
        DueDate: "",
        CreditUsed: "",
        ChartOfAccount: "",
        AP: "-",
        AR: "-",
        Balance: "",
        row_num: 0,
        showAll: false,
      };

      // Update viewRegisterData
      const updatedViewRegisterData = [newRow, ...viewRegisterData];
      setViewRegisterData(updatedViewRegisterData);
      setTimeout(() => {
        setCurrentData(updatedViewRegisterData?.slice(0, ITEMS_PER_PAGE));
        setCurrentPage(1);
        setStartIndex(0);
        setShowNewRow(true);
      }, 300);
    }
  };

  const getPayeeUserType = (transactions) => {
    if (transactions?.length > 0) {
      const value = transactions[0]?.value;
      const customerValues = [17, 11, 22];
      const nonCustomerValues = [6, 13, 14, 20, 21, 15, 12];

      if (nonCustomerValues.includes(value)) return "";
      if (customerValues.includes(value)) return "Customer";
      return "Supplier";
    }
    return 0;
  };

  useEffect(() => {
    AccountAPI();
    transactionType();
    payeeAPI();
  }, []);

  useEffect(() => {
    if (paramObject?.id != undefined) {
      setSelectChartOfAccountId(paramObject?.id);
      setChartOfAccountDetails(
        chartOfAccountDropdown?.find((el) => el?.value == paramObject?.id)
      );
      setShowNewRow(false);
    }

    handleViewRegisterAPI(
      searchText,
      selectTransactionType,
      customerId,
      supplierId,
      beginningDate,
      finalDate,
      paramObject?.id, // account ID
      employeeId
    );
  }, [
    searchText,
    selectTransactionType,
    customerId,
    supplierId,
    employeeId,
    beginningDate,
    finalDate,
    paramObject?.id,
  ]);

  console.log(
    selectTransactionType,
    "selectTransactionType | ",
    customerId,
    "customerId | ",
    supplierId,
    "supplierId | ",
    employeeId,
    "employeeId | ",
    beginningDate,
    "startDate | ",
    finalDate,
    "endDate | "
  );

  // const totalPages = Math.ceil(viewRegisterData?.length / ITEMS_PER_PAGE);

  // const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;

  // const currentData = viewRegisterData?.slice(
  //   startIndex,
  //   startIndex + ITEMS_PER_PAGE
  // );

  console.log(currentData, "viewRegisterData new");
  console.log(viewRegisterData, "viewRegisterData old");

  const totalPages = Math.ceil(viewRegisterData?.length / ITEMS_PER_PAGE);

  const handlePageChange = (type) => {
    setLoading(true);
    setCurrentData([]);
    let newPage;
    switch (type) {
      case "first":
        newPage = 1;
        break;
      case "last":
        newPage = totalPages;
        break;
      case "next":
        newPage = Math.min(currentPage + 1, totalPages);
        break;
      case "previous":
        newPage = Math.max(currentPage - 1, 1);
        break;
      default:
        newPage = currentPage;
    }

    setCurrentPage(newPage);
    const startIndexNo = (newPage - 1) * ITEMS_PER_PAGE;
    setStartIndex(startIndexNo);
    const newCurrentData = viewRegisterData.slice(
      startIndexNo,
      startIndexNo + ITEMS_PER_PAGE
    );
    setTimeout(() => {
      setCurrentData(newCurrentData);
      setLoading(false);
    }, 500);
  };

  return (
    <>
      <Sidebar />
      <Loader loading={loading} />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          {/* Page Header */}
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <div className="col"> */}
              {/* <h6 className="page-title">Accounting</h6> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/accounting">Account</Link>
                </li>
                <li className="breadcrumb-item active">View Register</li>
              </ul>
              {/* </div> */}
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <div className="col-lg-12 col-md-6 col-sm-12">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    <div style={{ marginBottom: "10px" }}>
                      <div className="col-form-label">Find</div>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="find"
                        name="find"
                        value={searchText}
                        onChange={(event) =>
                          setSearchText(event?.target?.value)
                        }
                        placeholder="Search..."
                      />
                    </div>
                  </div>
                  <div style={{ width: "16%" }}>
                    <div className="col-form-label">Transaction Type</div>
                    <Select
                      options={transactionTypeDropdown}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      isClearable={true}
                      value={transactionTypeDropdown.find(
                        (option) => option?.value == selectTransactionType
                      )}
                      onChange={(event) => {
                        setSelectTransactionType(
                          event?.value ? event?.value : 1
                        );
                      }}
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      className="custom-search-select"
                    />
                  </div>
                  <div style={{ width: "20%" }}>
                    <div className="col-form-label">Payee </div>
                    <Select
                      options={payeePersonList}
                      onChange={(event) => {
                        console.log(event, "eventdata");
                        handlePayeeType(event);
                      }}
                      value={payeePersonList.find((item) => item.value == "")}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      isClearable={true}
                      id="userid"
                      name="userid"
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      className="custom-search-select"
                    />
                  </div>
                  <div style={{ width: "17%" }}>
                    <div className="col-form-label"> Date </div>
                    <Select
                      onChange={(event) => {
                        handleDateFilter(event);
                      }}
                      options={dateOptions}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      // isClearable={true}
                      // defaultValue={5}
                      // isClearable={false}
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      value={dateOptions.find((el) => el?.value == customeDate)}
                      className="custom-search-select"
                    />
                  </div>
                  <div style={{ width: "12%" }}>
                    <div className="col-form-label">From</div>
                    <CommonDatePicker
                      FinalDate={beginningDate}
                      handleDateChange={handleDate}
                      showDefaultDate={
                        beginningDate && customeDate !== 0 ? true : false
                      }
                    />
                    {/* <input
                      type="date"
                      className="form-control form-control-sm"
                      id="StartDate"
                      name="StartDate"
                      value={beginningDate}
                      onChange={(event) => handleDate(event)}
                    /> */}
                  </div>
                  <div style={{ width: "12%" }}>
                    <div className="col-form-label">To: </div>
                    <CommonDatePicker
                      FinalDate={finalDate}
                      handleDateChange={handleEndDate}
                      showDefaultDate={
                        finalDate && customeDate !== 0 ? true : false
                      }
                    />
                    {/* <input
                      type="date"
                      className="form-control form-control-sm"
                      id="StartDate"
                      name="StartDate"
                      value={finalDate}
                      onChange={(event) => handleEndDate(event)}
                    /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  paddingBottom: "15px",
                }}
              >
                <div style={{ width: "60%", display: "flex" }}>
                  {!accountId && (
                    <button
                      // disabled={showNewRow}
                      type="button"
                      className="btn btn-sm btn-secondary  btn-sm pull-left"
                      style={{ margin: "18px 30px 1px 0", height: "37px" }}
                      onClick={
                        () => addNewRowForViewRegister()
                        // setShowNewRow(true)
                      }
                    >
                      <i className="fa fa-plus fa-sm" /> Add
                    </button>
                  )}
                  <div className="col-md-6 mb-4 col-form-control">
                    <strong>Account</strong>
                    <Select
                      options={chartOfAccountDropdown}
                      onChange={(e) => handleAccountChange(e)}
                      value={chartOfAccountDropdown.find(
                        (option) => option?.value == selectChartOfAccountId //?.value
                      )}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      hideSelectedOptions={true}
                      // isClearable={true}
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      id="AccountId"
                      name="AccountId"
                      className="custom-search-select"
                    />
                  </div>
                </div>
                <div className="d-flex">
                  <div className="d-flex justify-content-between align-items-end mr-8">
                    <div>
                      <span
                        className="me-2 cursor-pointer"
                        onClick={() => handlePageChange("first")}
                        disabled={currentPage === 1}
                      >
                        <u>First</u>
                      </span>
                      <span
                        className="me-2 cursor-pointer"
                        onClick={() => handlePageChange("previous")}
                        disabled={currentPage === 1}
                      >
                        <u>Previous</u>
                      </span>
                      <span>
                        Page {currentPage} of {totalPages} (Total Records:{" "}
                        {viewRegisterData?.length}){" "}
                      </span>
                      <span
                        className="me-2 cursor-pointer"
                        onClick={() => handlePageChange("next")}
                        disabled={currentPage === totalPages}
                      >
                        <u>Next</u>
                      </span>
                      <span
                        className="me-2 cursor-pointer"
                        onClick={() => handlePageChange("last")}
                        disabled={currentPage === totalPages}
                      >
                        <u>Last</u>
                      </span>
                    </div>
                  </div>
                  <div>
                    <p class="p-medium">Balance</p>
                    {/* <p className="text-right p">${amount ? amount : 0}</p> */}
                    {/* <p className="text-right p">${amountforAPandAR}</p> */}
                    <p className="text-right p">
                      $
                      {
                        chartOfAccountDropdown.find(
                          (option) => option?.value == selectChartOfAccountId //?.value
                        )?.amount
                      }
                    </p>
                    <p>
                      <strong>Sum Balance: </strong>
                      {viewRegisterData?.length > 0
                        ? Number(
                            viewRegisterData[viewRegisterData?.length - 1]
                              ?.Balance
                          ).toFixed(2)
                        : 0}
                    </p>
                  </div>
                </div>
              </div>

              <div>
                {/* table */}
                <table
                  className="table custom-table"
                  style={{ width: "100%", textAlign: "center" }}
                >
                  <thead style={{ borderBottom: "1px solid #1a2649" }}>
                    <tr>
                      <th name="Date" id="Date" style={{ width: "4rem" }}>
                        Date
                      </th>
                      <th
                        // onClick={(e) => handelSortByAscDesc(e)}
                        name="RefNo"
                        id="RefNo"
                        style={{ cursor: "pointer" }}
                      >
                        Ref No.
                        {/* <i class="fa fa-sort"></i> */}
                      </th>
                      <th
                        style={{ width: "10rem", cursor: "pointer" }}
                        // onClick={(e) => handelSortByAscDesc(e)}
                        name="Payee"
                        id="Payee"
                      >
                        Payee
                        {/* <i class="fa fa-sort"></i> */}
                      </th>

                      <th
                        name="Payment"
                        id="Payment"
                        // onClick={(e) => handelSortByAscDesc(e)}
                        style={{ cursor: "pointer" }}
                      >
                        {accountId || otherAccountId
                          ? "Charge/Credit"
                          : "Payment(DR)"}{" "}
                        {/* <i class="fa fa-sort"></i> */}
                      </th>
                      <th
                        name="Deposit"
                        id="Deposit"
                        // onClick={(e) => handelSortByAscDesc(e)}
                        style={{ cursor: "pointer" }}
                      >
                        {accountId || otherAccountId
                          ? "Payment"
                          : "Deposit(CR)"}{" "}
                        {/* <i class="fa fa-sort"></i> */}
                      </th>
                      <th name="cr" id="cr" style={{ padding: "0px" }}>
                        C/R
                      </th>
                      <th
                        name="Balance"
                        id="Balance"
                        // onClick={(e) => handelSortByAscDesc(e)}
                        style={{ cursor: "pointer" }}
                      >
                        Balance
                        {/* <i class="fa fa-sort"></i> */}
                      </th>
                      {/* <th>Action</th> */}
                    </tr>
                    <tr>
                      <th></th>
                      <th
                        name="Type"
                        id="Type"
                        // onClick={(e) => handelSortByAscDesc(e)}
                        style={{ cursor: "pointer" }}
                      >
                        Type
                        {/* <i class="fa fa-sort"></i> */}
                      </th>
                      <th
                        name="AccountID"
                        id="AccountID"
                        // onClick={(e) => handelSortByAscDesc(e)}
                        style={{ width: "10rem", cursor: "pointer" }}
                      >
                        Account
                        {/* <i class="fa fa-sort"></i> */}
                      </th>
                      <th style={{ width: "10rem" }}></th>
                      <th> {accountId ? "DueDate" : ""}</th>
                      <th></th>
                      {/* <th></th> */}
                      <th style={{ width: "4rem" }}></th>
                      {/* <th></th> */}
                      {/* <th></th> */}
                    </tr>
                    <tr>
                      <th></th>
                      <th></th>
                      <th
                        name="Memo"
                        id="Memo"
                        // onClick={(e) => handelSortByAscDesc(e)}
                        style={{ cursor: "pointer" }}
                      >
                        Memo
                        {/* <i class="fa fa-sort"></i> */}
                      </th>
                      <th style={{ width: "10rem" }}></th>
                      <th></th>
                      <th></th>
                      {/* <th></th> */}
                      <th style={{ width: "4rem" }}></th>
                      {/* <th></th> */}
                      {/* <th></th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {/* {viewRegisterData?.map((item, index) => { */}
                    {currentData?.map((item, index) => {
                      // {descRowsData?.map((item, index) => {

                      // return accountValue === 5 ? (
                      //   ""
                      // ) :
                      return (
                        <tr
                          style={{
                            borderBottom: "1px solid var(--primary-color-50)",
                            marginBottom: "10px",
                          }}
                          key={index}
                        >
                          <td
                            style={{
                              padding: "1px",
                              textAlign: "-webkit-center",
                              verticalAlign: "-webkit-baseline-middle",
                              width: "10%",
                              fontSize: "12px",
                            }}
                          >
                            <Flatpickr
                              className="form-control form-control-sm ml-2"
                              type="date"
                              id="date"
                              name="date"
                              // style={{
                              //   height: "31px",
                              //   width: "85%",
                              //   marginTop: "2px",
                              // }}
                              options={{
                                dateFormat: "m/d/Y",
                                altInput: true,
                                altFormat: "m/d/Y",
                              }}
                              style={{ width: "85%" }}
                              // value={moment(item?.Date).format("YYYY-MM-DD")}
                              value={
                                moment(item?.Date).format(
                                  "YYYY-MM-DDT00:00:00.000"
                                ) + "Z"
                              }
                              onChange={(event) =>
                                handleInputChange(
                                  event,
                                  startIndex + index,
                                  "Date",
                                  index
                                )
                              }
                              disabled={item?.IsDefaultBalance == 1}
                              // disabled={
                              //   showNewRow
                              //     ? false
                              //     : //   item?.TransactionTypeID == 3 ||
                              //     //   item?.TransactionTypeID == 8 ||
                              //     //   item?.TransactionTypeID == 9 ||
                              //     item?.IsDefaultBalance == 1
                              //     ? true
                              //     : false
                              // }
                            />
                          </td>
                          <td
                            style={{
                              padding: "1px",
                              verticalAlign: "-webkit-baseline-middle",
                              width: "36%",
                              marginLeft: "2px",
                              lineHeight: "20px",
                              // border: "1px solid red",
                              fontSize: "12px",
                            }}
                          >
                            <input
                              className="form-control form-control-sm col-md-12 "
                              type="text"
                              id="refno"
                              name="refno"
                              placeholder="Reference No."
                              style={{
                                ...inputStyles,
                                backgroundColor:
                                  item?.TransactionTypeID === 12 ||
                                  item?.TransactionTypeID === 13
                                    ? "dark"
                                    : "",
                              }}
                              onChange={(event) =>
                                handleInputChange(
                                  event?.target?.value,
                                  startIndex + index,
                                  "RefNo",
                                  index
                                )
                              }
                              defaultValue={item?.RefNo}
                              disabled={
                                showNewRow
                                  ? item?.TransactionTypeID == 12 ||
                                    item?.TransactionTypeID == 13
                                    ? true
                                    : false
                                  : item?.TransactionTypeID == 12 ||
                                    item?.TransactionTypeID == 13 ||
                                    (item?.TransactionTypeID == 6 &&
                                      item?.IsOppositeEntry == 1) // ||
                                  ? // item?.TransactionTypeID == 8 ||
                                    // item?.TransactionTypeID == 9
                                    // item?.TransactionTypeID == 6 ||
                                    true
                                  : false
                              }
                            />
                            {/* <td style={{ padding: "1px",textAlign: "-webkit-center",width:"176px" }}>
                                    <> */}
                            <Select
                              // onChange={(event) => {
                              //   handleAccountType(event)
                              // }}
                              // value={transactionTypeDropdown?.find((option) => option?.value === item?.TransactionTypeID)}
                              // options={transactionTypeDropdown}
                              options={filteredTransactions}
                              value={filteredTransactions?.find(
                                (option) =>
                                  option?.value == item?.TransactionTypeID
                              )}
                              onChange={(event) =>
                                handleInputChange(
                                  event,
                                  startIndex + index,
                                  "Type",
                                  index
                                )
                              }
                              backspaceRemovesValue={false}
                              controlShouldRenderValue={true}
                              styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                              className="custom-search-select col-md-11 mt-3 ml-2"
                              placeholder="Type"
                              id="Type"
                              name="Type"
                              isDisabled={item?.ID > 0 ? true : false} // 11,
                              // isOptionDisabled={true}
                            />
                            {/* {item?.Module} */}
                            {/* {item?.TransactionTypeID} */}
                          </td>
                          <td
                            style={{
                              padding: "1px",
                              verticalAlign: "-webkit-baseline-middle",
                              lineHeight: "20px",
                              width: "50%",
                              fontSize: "12px",
                            }}
                          >
                            {item.IsCustomerSplit == 1 ? (
                              <>
                                <button
                                  className="btn btn-sm btn-outline-primary btn-custom-padding col-md-11  mt-2 ml-2"
                                  data-toggle="tooltip"
                                  data-placement="bottom"
                                  data-bs-toggle="modal"
                                  data-bs-target="#SplittingConfirmationModal"
                                  onClick={() => Spilliting(item?.SplitRecords)}
                                  // style={{ width: "100%" }}
                                >
                                  -Split-
                                </button>
                              </>
                            ) : (
                              <Select
                                // onChange={(event) => {
                                //   handleAppointmentPerson(event)
                                // }}
                                onChange={(event) =>
                                  handleInputChange(
                                    event,
                                    startIndex + index,
                                    "PayeeId",
                                    index
                                  )
                                }
                                options={
                                  item?.TransactionTypeID == 6 ||
                                  item?.TransactionTypeID == 13 ||
                                  item?.TransactionTypeID == 14 ||
                                  item?.TransactionTypeID == 20 ||
                                  item?.TransactionTypeID == 21 ||
                                  item?.TransactionTypeID == 15 ||
                                  item?.TransactionTypeID == 12
                                    ? payeePersonList
                                    : payeePersonList?.filter(
                                        (el) =>
                                          el?.UserType === item?.PayeeUserType
                                      )
                                }
                                backspaceRemovesValue={false}
                                controlShouldRenderValue={true}
                                value={
                                  item?.PayeeId == 0
                                    ? null
                                    : payeePersonList
                                        ?.filter(
                                          (el) =>
                                            el?.UserType === item?.PayeeUserType
                                        )
                                        ?.find(
                                          (option) =>
                                            option?.value == item?.PayeeId
                                        )
                                }
                                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                placeholder={
                                  "Please Select the Transaction Type First"
                                  // : "Payee"
                                }
                                id="Payee"
                                name="Payee"
                                className="custom-search-select col-md-11 ml-2"
                                isDisabled={
                                  showNewRow
                                    ? item?.TransactionTypeID == 13
                                      ? true
                                      : false
                                    : item?.TransactionTypeID == 12 ||
                                      item?.TransactionTypeID == 11 ||
                                      item?.TransactionTypeID == 7 ||
                                      item?.TransactionTypeID == 13
                                    ? true
                                    : false
                                }
                              />
                            )}
                            {/* {item?.PayeeId} */}
                            {/* {item?.PayeeUserType + " : " + item?.PayeeId} : 45 {item?.showAll} */}
                            {/* <td style={{ padding: "1px" textAlign: "-webkit-center",}}> */}
                            {item.IsSplit == 1 ? (
                              <>
                                <button
                                  className="btn btn-sm btn-outline-primary btn-custom-padding col-md-11  mt-2 ml-2"
                                  data-toggle="tooltip"
                                  data-placement="bottom"
                                  data-bs-toggle="modal"
                                  data-bs-target="#SplittingConfirmationModal"
                                  onClick={() => Spilliting(item?.SplitRecords)}
                                  // style={{ width: "100%" }}
                                >
                                  -Split-
                                </button>
                              </>
                            ) : (
                              <Select
                                // onChange={(e, i) => {
                                //   setAccountId(e?.value);
                                //   handleQuickBookChange(e, i);
                                // }}
                                onChange={(event) =>
                                  handleInputChange(
                                    event,
                                    startIndex + index,
                                    "AccountID",
                                    index
                                  )
                                }
                                value={chartOfAccountDropdown.find(
                                  (option) => option?.value == item?.AccountID
                                )}
                                options={chartOfAccountDropdown}
                                backspaceRemovesValue={false}
                                controlShouldRenderValue={true}
                                hideSelectedOptions={true}
                                isClearable={false}
                                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                id="AccountId"
                                name="AccountId"
                                // isDisabled={true} //item?.IsDefaultBalance == 1}
                                isDisabled={
                                  showNewRow && index === 0
                                    ? item?.TransactionTypeID == 7 ||
                                      item?.TransactionTypeID == 11 ||
                                      item?.TransactionTypeID == 17 ||
                                      item?.TransactionTypeID == 22
                                      ? true
                                      : false
                                    : item?.TransactionTypeID == 11 ||
                                      (item?.TransactionTypeID == 6 &&
                                        item?.IsOppositeEntry == 1) ||
                                      item?.TransactionTypeID == 7 ||
                                      item?.TransactionTypeID == 17 ||
                                      item?.TransactionTypeID == 22 ||
                                      (item?.TransactionTypeID == 12 &&
                                        item?.Memo === "Opening Balance") ||
                                      (item?.TransactionTypeID == 12 &&
                                        item?.IsOppositeEntry == 1) ||
                                      (item?.TransactionTypeID == 14 &&
                                        item?.IsSplit == 1) // ||
                                    ? // item?.TransactionTypeID == 9 ||
                                      // item?.IsDefaultBalance == 1
                                      true
                                    : false
                                }
                                className="custom-search-select mt-3 col-md-11 ml-2"
                              />
                            )}

                            <input
                              className="form-control form-control-sm mt-3 col-md-12 mb-3"
                              type="text"
                              style={inputStyles}
                              placeholder="Memo"
                              onChange={(event) =>
                                handleInputChange(
                                  event,
                                  startIndex + index,
                                  "Memo",
                                  index
                                )
                              }
                              value={item?.Memo}
                              disabled={
                                item?.IsDefaultBalance == 1
                                // showNewRow
                                //   ? false
                                //   : item?.IsDefaultBalance == 1
                                //   ? true
                                //   : false
                              }
                            />

                            {/* <span className="ml-2">{item?.AmountPaid}</span>
                                <br></br>
                                <span className="ml-2">{item?.CreditNote}</span> */}
                            {/* </td> */}
                          </td>
                          {/* <td style={{ padding: "1px" textAlign: "-webkit-center",}}>

                                  {item.IsSplit == 1 ?
                                    <>
                                      <button className="btn btn-sm btn-outline-primary btn-custom-padding" data-toggle="tooltip" data-placement="bottom"
                                        data-bs-toggle="modal"
                                        data-bs-target="#SplittingConfirmationModal"
                                        onClick={() => Spilliting(item.SplitRecords)}
                                        style={{ "width": "100%" }}>

                                        -Split-
                                      </button>
                                    </>
                                    : <Select
                                      // onChange={(e, i) => {
                                      //   setAccountId(e?.value);
                                      //   handleQuickBookChange(e, i);
                                      // }}
                                      onChange={(event) => handleInputChange(event, index, "AccountID")}
                                      value={accountTypeDropdownOption.find(
                                        (option) => option?.value == item?.AccountID
                                      )}
                                      options={accountTypeDropdownOption}
                                      backspaceRemovesValue={false}
                                      controlShouldRenderValue={true}
                                      hideSelectedOptions={true}
                                      isClearable={true}
                                      styles={CUSTOM_SELECT_DROPDOWN_STYLE }
                                      id="AccountId"
                                      name="AccountId"
                                      isDisabled={item?.IsDefaultBalance == 1}
                                    />

                                  }
                                </td> */}
                          {/* <td
                            style={{
                              
                              verticalAlign: "-webkit-baseline-middle",
                              width: "35%",
                              fontSize: "12px",
                            }}
                          >
                            
                          </td> */}
                          <td
                            style={{
                              // padding: "1px",
                              textAlign: "-webkit-center",
                              verticalAlign: "-webkit-baseline-middle",
                              width: "27%",
                              fontSize: "12px",
                            }}
                          >
                            <>
                              <input
                                className="form-control form-control-sm "
                                type="number"
                                style={{ width: "99px", fontSize: "12px" }}
                                // style={inputStyles}
                                value={item?.Payment}
                                onChange={(event) =>
                                  handleInputChange(
                                    event,
                                    startIndex + index,
                                    "Payment",
                                    index
                                  )
                                }
                                disabled={
                                  showNewRow && index === 0
                                    ? // item?.TransactionTypeID == 6 ||
                                      item?.TransactionTypeID == 11 ||
                                      item?.TransactionTypeID == 17 ||
                                      item?.TransactionTypeID == 21 ||
                                      item?.TransactionTypeID == 12
                                      ? // || item?.TransactionTypeID == 12
                                        true
                                      : false
                                    : // : item?.TransactionTypeID == 12 ||
                                    item?.TransactionTypeID == 7 ||
                                      item?.TransactionTypeID == 21 ||
                                      item?.TransactionTypeID == 11 ||
                                      item?.TransactionTypeID == 14 ||
                                      item?.TransactionTypeID == 17 ||
                                      item?.TransactionTypeID == 22 ||
                                      // (item?.TransactionTypeID == 12 && item.Payment !== 0 ) ||
                                      (item?.TransactionTypeID == 12 &&
                                        item?.IsOppositeEntry == 0) ||
                                      (item?.TransactionTypeID == 6 &&
                                        item?.IsOppositeEntry == 1) ||
                                      // item?.TransactionTypeID == 6 ||
                                      item?.IsSplit == 1 ||
                                      (item?.TransactionTypeID == 13 &&
                                        item?.Payment == 0) // ||
                                    ? // item?.IsDefaultBalance == 1 ||

                                      true
                                    : false
                                }
                              />

                              {showNewRow &&
                              (item?.TransactionTypeID == 7 ||
                                item?.TransactionTypeID == 11) ? (
                                <>
                                  <Select
                                    onChange={
                                      (event) =>
                                        handleInputChange(
                                          event,
                                          startIndex + index,
                                          "BillInvoice",
                                          index
                                        )
                                      // handleNewInputChange(value, "BillInvoice")
                                    }
                                    value={
                                      billInvoiceSelect
                                        ? pendinginvoice?.find(
                                            (el) =>
                                              el?.value == billInvoiceSelect
                                          )
                                        : null
                                    }
                                    options={pendinginvoice}
                                    backspaceRemovesValue={false}
                                    controlShouldRenderValue={true}
                                    hideSelectedOptions={true}
                                    // styles={CUSTOM_SELECT_DROPDOWN_STYLE }
                                    styles={selectDropdownStyles}
                                    // isMulti={true}
                                    // isClearable={true}
                                    className="col-md-11 mt-3 custom-search-select"
                                    placeholder={
                                      item?.TransactionTypeID == 7
                                        ? "Bill No."
                                        : item?.TransactionTypeID == 11
                                        ? "Invoice No"
                                        : ""
                                    }
                                    id="BillInvoice"
                                    name="BillInvoice"
                                  />
                                </>
                              ) : (
                                ""
                              )}
                              {/* <br></br>
                              <span
                                className="ml-2"
                                style={{ textAlign: "left" }}
                              >
                                <strong>{item?.AmountPaid}</strong>
                              </span>
                              <br></br> */}
                              {/* {item?.CreditNote > 0 && (
                                <span
                                  className="ml-4"
                                  style={{ textAlign: "left" }}
                                >
                                  <strong>
                                    Credit Applied:{" "}
                                    {parseInt(item?.CreditNote).toFixed(2)}
                                  </strong>
                                </span>
                              )} */}
                            </>
                          </td>

                          <td
                            style={{
                              padding: "1px",
                              textAlign: "-webkit-center",
                              verticalAlign: "-webkit-baseline-middle",
                            }}
                          >
                            <input
                              className="form-control form-control-sm"
                              type="number"
                              style={{ width: "99px", fontSize: "12px" }}
                              // style={inputStyles}
                              value={item?.Deposit}
                              onChange={(event) =>
                                handleInputChange(
                                  event,
                                  startIndex + index,
                                  "Deposit",
                                  index
                                )
                              }
                              disabled={
                                showNewRow && index === 0
                                  ? item?.TransactionTypeID == 7 ||
                                    item?.TransactionTypeID == 22 ||
                                    item?.TransactionTypeID == 6 ||
                                    item?.TransactionTypeID == 20
                                    ? true
                                    : false
                                  : (item?.TransactionTypeID == 13 &&
                                      item?.Deposit == 0) ||
                                    item?.IsSplit == 1 ||
                                    item?.TransactionTypeID == 14 ||
                                    item?.TransactionTypeID == 20 ||
                                    item?.TransactionTypeID == 15 ||
                                    item?.TransactionTypeID == 17 ||
                                    item?.TransactionTypeID == 22 ||
                                    // item?.TransactionTypeID == 6 ||
                                    (item?.TransactionTypeID == 6 &&
                                      item?.IsOppositeEntry == 0) ||
                                    item?.TransactionTypeID == 7 ||
                                    (item?.TransactionTypeID == 12 &&
                                      item?.Memo === "Opening Balance") ||
                                    (item?.TransactionTypeID == 12 &&
                                      item?.IsOppositeEntry == 1) ||
                                    item?.TransactionTypeID == 11 // ||
                                  ? // item?.TransactionTypeID == 6 ||
                                    // item?.TransactionTypeID == 13 ||
                                    // item?.IsDefaultBalance == 1 ||

                                    true
                                  : false
                              }
                            />
                            {showNewRow &&
                            (item?.TransactionTypeID == 7 ||
                              item?.TransactionTypeID == 11) ? (
                              <div>
                                {labelinvoice?.length > 0 &&
                                  labelinvoice?.map((item, index) => {
                                    return (
                                      <div>
                                        <p key={index}>
                                          {item.label.split("(")[0].trim()}:{" "}
                                          {item.total}
                                        </p>
                                      </div>
                                    );
                                  })}
                              </div>
                            ) : (
                              ""
                            )}

                            <td>
                              {" "}
                              {accountId
                                ? `${
                                    item?.DueDate
                                      ? moment(item?.DueDate).format(
                                          "YYYY-MM-DD"
                                        )
                                      : ""
                                  }`
                                : ""}
                            </td>
                            {(startIndex + index == 0 && !showNewRow) ||
                            item?.Type === "Opening Balance" ||
                            accountId ||
                            item?.Deleted === 1 ? (
                              ""
                            ) : (
                              <button
                                type="button"
                                class="btn btn-primary btn-sm mr-1 "
                                onClick={() =>
                                  showNewRow
                                    ? handleSubmit("add")
                                    : handleSubmit(
                                        "edit",
                                        startIndex + index,
                                        item.IsSplit,
                                        index
                                      )
                                }
                              >
                                Save
                              </button>
                            )}
                          </td>
                          <td
                            style={{
                              padding: "1px",
                              textAlign: "-webkit-center",
                              verticalAlign: "-webkit-baseline-middle",
                              width: "27%",
                              // border: "1px solid red",
                              fontSize: "12px",
                            }}
                          >
                            <input
                              value={viewRegisterData[startIndex + index]?.cr}
                              className="form-control form-control-sm"
                              // style={inputStyles}
                              style={{
                                fontSize: "12px",
                                width: "45px",
                                cursor: "pointer",
                              }}
                              //placeholder="C/R"
                              type="text"
                              onClick={() =>
                                handleRowInputClick(startIndex + index, index)
                              }
                              onChange={(event) => event}
                              // disabled={item?.IsDefaultBalance === 1}
                              disabled={
                                // item?.IsDefaultBalance == 1
                                //   ? true
                                //   : false
                                false
                              }
                              // readOnly
                            />

                            <td></td>
                            {accountId || showNewRow
                              ? ""
                              : item?.Type !== "Opening Balance" &&
                                item?.Deleted !== 1 && (
                                  <button
                                    type="button"
                                    class="btn btn-secondary btn-sm mb-1 mr-1"
                                    onClick={() =>
                                      handleEdit(
                                        item?.TransactionTypeID,
                                        item?.ID,
                                        item?.Type,
                                        item?.RecSaleID
                                      )
                                    }
                                  >
                                    Edit
                                  </button>
                                )}

                            {showNewRow && index === 0 && (
                              <button
                                type="button"
                                class="btn btn-secondary mt-2"
                                onClick={() => handleRemove()}
                              >
                                Cancel
                              </button>
                            )}
                          </td>
                          <td
                            style={{
                              padding: "1px",
                              textAlign: "-webkit-center",
                              verticalAlign: "-webkit-baseline-middle",
                              width: "27%",
                              // border: "1px solid red",
                              fontSize: "12px",
                            }}
                          >
                            {item?.Balance < 0 ? (
                              <p
                                className="mb-2 font-bold"
                                style={{ color: "var(--error-main-color)" }}
                              >
                                {Number(item.Balance).toFixed(2)}
                              </p>
                            ) : selectTransactionType === 1 ||
                              selectTransactionType === undefined ? (
                              <p
                                className="mb-2 font-bold"
                                style={{ color: "var(--success-main-color)" }}
                              >
                                {Number(item.Balance).toFixed(2)}
                              </p>
                            ) : startIndex + index === 0 ? (
                              <>
                                <p>(Only displayed with</p>
                                <p>date/reconcile </p>
                                <p>status sort)</p>
                              </>
                            ) : (
                              "n/a"
                            )}
                            <td></td>
                            <td></td>
                            {accountId ||
                            (showNewRow && index === 0) ||
                            item?.Deleted === 1 ? (
                              ""
                            ) : item?.IsDefaultBalance != 1 ? (
                              <div class="row">
                                <div class="col-md-12">
                                  {
                                    <>
                                      {item.IsDefaultBalance == 0 && (
                                        <>
                                          <button
                                            type="button"
                                            class="btn btn-secondary btn-sm  mt-1"
                                            onClick={() =>
                                              handleDeleteClick(
                                                item,
                                                startIndex + index
                                              )
                                            }
                                          >
                                            Delete
                                          </button>
                                        </>
                                      )}
                                    </>
                                  }
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            <div
                              className={`modal ${
                                stateModal.visible === startIndex + index
                                  ? "d-block"
                                  : ""
                              }`}
                              tabIndex="-1"
                              style={{ background: "rgba(0,0,0,0.2)" }}
                            >
                              <div className="modal-dialog modal-sm modal-dialog-centered">
                                <div className="modal-content">
                                  <div className="modal-header">
                                    <h5 className="title-model">
                                      Confirmation
                                    </h5>
                                    <button
                                      type="button"
                                      className="btn-close"
                                      data-bs-dismiss="modal"
                                      aria-label="Close"
                                      onClick={handleClose}
                                    >
                                      <span aria-hidden="true">×</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <p className="mb-2">
                                          Are you sure you want to delete this
                                          row?
                                        </p>
                                        {false && (
                                          <>
                                            <p className=" text-danger">
                                              Note: Credit delete need to
                                              deleted manually
                                            </p>
                                            <p className=" text-danger">
                                              from the QuickBook because it
                                              won't SYNC.
                                            </p>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="modal-footer justify-content-center">
                                    <button
                                      type="button"
                                      className="btn btn-primary"
                                      onClick={() => handleConfirmDelete()}
                                      checkafter
                                    >
                                      Delete
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-secondary"
                                      onClick={handleCancelDelete}
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>

                          {/* <td style={{ padding: "1px",textAlign: "-webkit-center",verticalAlign: "-webkit-baseline-middle"}}> */}
                          {/* <div class="row">
                                    <div class="col-md-12">
                                      {
                                        <>
                                          {
                                            item.IsDefaultBalance == 0 && (<button type="button" class="btn btn-outline-primary  btn-sm btn-custom-padding mr-1" onClick={() => handleSubmit("edit", index, item.IsSplit)}>
                                              <i class="fa fa-check" ></i>
                                            </button>)
                                          }
                                          {
                                            item.showDelete && item.IsDefaultBalance == 0 && (
                                              <button type="button" class="btn btn-outline-danger  btn-sm btn-custom-padding mr-1" onClick={() => handleDeleteClick(item, index)}>
                                                <i class="fa fa-trash"></i>
                                              </button>
                                            )
                                          }
                                        </>
                                      }
                                    </div>
                                  </div> */}
                          {/* Delete confirmation modal */}
                          {/* <div
                                    className={`modal ${stateModal.visible === index ? "d-block" : ""}`}
                                    tabIndex="-1"
                                    style={{ background: "rgba(0,0,0,0.2)" }}
                                  >
                                    <div className="modal-dialog modal-dialog-centered">
                                      <div className="modal-content">
                                        <div className="modal-header">
                                          <h5 className="modal-title">Confirmation</h5>
                                          <button
                                            type="button"
                                            className="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                            onClick={handleClose}
                                          >
                                            <span aria-hidden="true">×</span>
                                          </button>
                                        </div>
                                        <div className="modal-body">
                                          <div className="row">
                                            <div className="col-lg-12">
                                              <h6>Are you sure you want to delete this row?</h6>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="modal-footer justify-content-center">
                                          <button type="button" className="btn btn-primary" onClick={() => handleConfirmDelete()}>
                                            Delete
                                          </button>
                                          <button type="button" className="btn btn-secondary" onClick={handleCancelDelete}>
                                            Cancel
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div> */}
                          {/* </td> */}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <div className="d-flex justify-content-between">
                  <button
                    className="btn btn-sm btn-secondary me-2"
                    onClick={() => navigate(-1)}
                    style={{ marginTop: "20px" }}
                  >
                    Back
                  </button>
                  <div style={{ marginTop: "20px" }}>
                    <button
                      className="btn btn-sm btn-secondary me-2"
                      onClick={() => handlePageChange("first")}
                      disabled={currentPage === 1}
                    >
                      First
                    </button>
                    <button
                      className="btn btn-sm btn-secondary me-2"
                      onClick={() => handlePageChange("previous")}
                      disabled={currentPage === 1}
                    >
                      Previous
                    </button>
                    <span>
                      Page {currentPage} of {totalPages} (Total Records:{" "}
                      {viewRegisterData?.length})
                    </span>
                    <button
                      className="btn btn-sm btn-secondary me-2"
                      onClick={() => handlePageChange("next")}
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>
                    <button
                      className="btn btn-sm btn-secondary me-2"
                      onClick={() => handlePageChange("last")}
                      disabled={currentPage === totalPages}
                    >
                      Last
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SplittingConfirmationModal SplitData={splits} />
    </>
  );
}

export default ViewRegisterQuickbook;
